import Vue from 'vue'
import Router from 'vue-router'
import singH5 from '@/components/singH5.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'singH5',
      component: singH5
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js